
import { PAGES_DASHBOARD, ssrI18n } from "@mosanic/i18n";
import { addBuilderMdl } from "@redux/builder";
import dynamic from "next/dynamic";
import { withRouter } from "next/router";
import { useEffect } from "react";


const Dashboard = dynamic(() => import(
  /* webpackChunkName: 'Dashboard' */
  "@mosanic/components/Dashboard"
  ), {
    ssr: false
})


const AppIndex = ({router, translated}) => {
  useEffect(() => {
    addBuilderMdl()
},[])

// useEffect(() => {
//     if (navigator?.geolocation) {
//       navigator.geolocation.getCurrentPosition((location) => {
//         alert(JSON.stringify(location))
//         // if (location) dispatch(getUserData(location.coords));
//       });
//     }
//   }, []);

  return (
    <>
      <Dashboard 
        translated={translated}
        type={router?.query?.type}
      />

      </>
  );
}
export const getStaticProps = async () => ({
  props: {
    translated: {
      title: ssrI18n('dash_title', PAGES_DASHBOARD),
      intro: ssrI18n('dash_intro', PAGES_DASHBOARD),
      cta: ssrI18n('dash_cta', PAGES_DASHBOARD),

      feedback: {
        title: ssrI18n('feedback_title', PAGES_DASHBOARD),
        intro: ssrI18n('feedback_intro', PAGES_DASHBOARD),
        cta: ssrI18n('feedback_cta', PAGES_DASHBOARD),
      }
    }
  }
})

export default withRouter(AppIndex);
